"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assert = exports.fillRef = exports.getText = exports.isDev = exports.concat = void 0;
var tslib_1 = require("tslib");
var react_1 = require("react");
function concat(prefix) {
    var suffix = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        suffix[_i - 1] = arguments[_i];
    }
    return tslib_1.__spreadArrays([prefix], suffix).join('-');
}
exports.concat = concat;
exports.isDev = process.env.NODE_ENV !== 'production';
/** 得到 ReactNode 中的文本 */
function getText(node) {
    return react_1.Children.toArray(node).map(function (child) {
        if (typeof child === 'string') {
            return child;
        }
        if (typeof child === 'number') {
            return child + '';
        }
        if (react_1.isValidElement(child) && child.props) {
            return getText(child.props.children);
        }
        return '';
    }).join(' ');
}
exports.getText = getText;
/** 使用给定的值填充给定 ref，支持 ref object 或 callback ref */
function fillRef(ref, value) {
    if (ref == null)
        return;
    if (typeof ref === 'function') {
        ref(value);
        return;
    }
    // ref.current 本来是 readonly 的
    ref.current = value;
}
exports.fillRef = fillRef;
function assert(predict, message) {
    if (typeof predict === 'boolean') {
        if (!predict)
            throw Error(message);
        return;
    }
    if (!predict()) {
        throw Error(message);
    }
}
exports.assert = assert;
//# sourceMappingURL=index.js.map